angular.module('bmsApp.settings').factory('DashboardApiSvc', function (CRUDSvc, DASHBOARD_API) {
	return {
		chart: function (params) {
			return CRUDSvc.get(DASHBOARD_API.CHART, params);
		},
		income: function(params){
			return CRUDSvc.get(DASHBOARD_API.INCOME, params);
		},
		marketingRevenue: function(params){
			return CRUDSvc.get(DASHBOARD_API.MARKETING_REVENUE, params);
		},
		initiativeMetrics: function(params) {
			return CRUDSvc.get(window.config.app.nitro_url + 'api-bms/campaign/performance-breakdown', params);
		},
		activeCustomersBreakdown: function(params){
			return CRUDSvc.get(DASHBOARD_API.ACTIVE_CUSTOMERS_BREAKDOWN, params);
		},
		newCustomersBreakdown: function(params){
			return CRUDSvc.get(DASHBOARD_API.NEW_CUSTOMERS_BREAKDOWN, params);
		},
		lostCustomersBreakdown: function(params){
			return CRUDSvc.get(DASHBOARD_API.LOST_CUSTOMERS_BREAKDOWN, params);
		},
		inactiveCustomersBreakdown: function(params){
			return CRUDSvc.get(DASHBOARD_API.INACTIVE_CUSTOMERS_BREAKDOWN, params);
		},
		initiativeRevenueBreakdown: function(params){
			return CRUDSvc.get(DASHBOARD_API.INITIATIVE_REVENUE_BREAKDOWN, params);
		},
		inactiveCleansBreakdown: function(params){
			return CRUDSvc.get(DASHBOARD_API.INACTIVE_CLEANS_BREAKDOWN, params);
		},
		employeeEarningsSummary: function(params){
			return CRUDSvc.get(DASHBOARD_API.EMPLOYEE_EARNINGS_SUMMARY, params);
		},
		travelTimeCost: function(params){
			return CRUDSvc.get(DASHBOARD_API.TRAVEL_TIME_COST, params);
		},
		smMTDSummary: function(params){
			return CRUDSvc.get(DASHBOARD_API.SM_MTD_SUMMARY, params);
		},
		resources: function(params) {
			return CRUDSvc.get(DASHBOARD_API.RESOURCES, params);
		},
	}
}).constant('DASHBOARD_API', {
	CHART: 'api/dashboard/chart',
	INCOME: 'api/dashboard/income',
	MARKETING_REVENUE: 'api/dashboard/marketingRevenue',
	INITIATIVE_METRICS: 'api/dashboard/initiativeMetrics',
	ACTIVE_CUSTOMERS_BREAKDOWN: 'api/dashboard/activeCustomersBreakdown',
	NEW_CUSTOMERS_BREAKDOWN: 'api/dashboard/newCustomersBreakdown',
	LOST_CUSTOMERS_BREAKDOWN: 'api/dashboard/lostCustomersBreakdown',
	INACTIVE_CUSTOMERS_BREAKDOWN: 'api/dashboard/inactiveCustomersBreakdown',
	INITIATIVE_REVENUE_BREAKDOWN: 'api/dashboard/initiativeRevenueBreakdown',
	INACTIVE_CLEANS_BREAKDOWN: 'api/dashboard/inactiveCleansBreakdown',
	EMPLOYEE_EARNINGS_SUMMARY: 'api/dashboard/employeeEarningsSummary',
	TRAVEL_TIME_COST: 'api/dashboard/travelTimeCost',
	SM_MTD_SUMMARY: 'api/dashboard/smMTDSummary',
	RESOURCES: 'api/dashboard/resources',
});



